import { useId } from 'react'
import { cn } from '@/lib/utils'

interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  labelVerborgenOpDesktop?: boolean
  disabled?: boolean
  id?: string
  className?: string
}

export function Checkbox({
  checked,
  onChange,
  label,
  labelVerborgenOpDesktop,
  disabled,
  id,
  className,
}: CheckboxProps) {
  const eigenId = useId()
  const vinkId = id ?? eigenId

  return (
    <label
      htmlFor={vinkId}
      className={cn('flex h-9 items-center gap-2 text-sm text-ink-soft', className)}
    >
      <input
        id={vinkId}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        aria-label={label && labelVerborgenOpDesktop ? label : undefined}
        onChange={(gebeurtenis) => onChange(gebeurtenis.target.checked)}
        className="h-4 w-4 rounded border-hairline accent-primair-600 disabled:opacity-45"
      />
      {label ? (
        <span className={labelVerborgenOpDesktop ? 'lg:hidden' : undefined}>{label}</span>
      ) : null}
    </label>
  )
}
